// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root .DSqfd{align-items:center;background-color:var(--anchore-color-brand-blue);color:var(--anchore-color-white);display:flex;justify-content:center;overflow-y:hidden;padding:0 1.2rem;position:fixed;width:100%;z-index:101}:root .DSqfd.s0yNM{height:var(--anchore-custom-banner-top-height);top:0}:root .DSqfd.RmPOT{bottom:0;height:var(--anchore-custom-banner-bottom-height)}:root .FNI6l{max-width:90vw!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customBanner": `DSqfd`,
	"top": `s0yNM`,
	"bottom": `RmPOT`,
	"textPopup": `FNI6l`
};
module.exports = ___CSS_LOADER_EXPORT___;
